<template>
  <div>
    <ReturnAdd />
  </div>
</template>

<script>
  import ReturnAdd from './returnAdd';

  export default {
    name: 'returnEdit',
    components: {
      ReturnAdd,
    },
  };
</script>
